import Transaction from './Transaction';
import { useTheme } from '../../contexts/Theme.context';
import { useCallback, useEffect, useState } from 'react';
import useWallets from '../../api/wallets';
import { useParams } from 'react-router';
import { useCurrentPeriod } from '../../contexts/CurrentPeriod.context';

export default function TransactionList({ transactions, clickTransaction, canFetch = false }) {

  const { compCode, walletCode } = useParams();
  const { getTransactionsOfWallet } = useWallets();

  const [trans, setTrans] = useState(transactions);

  const {start, end} = useCurrentPeriod();

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const result = await getTransactionsOfWallet({
          compId: compCode,
          walletId: walletCode
        });
        console.log(result);
        setTrans(result?.transactions || []); 
      } catch (error) {
        console.error("Failed to fetch transactions:", error);
        setTrans([]); 
      }
    };

    if (canFetch && compCode && walletCode) {
      fetchTransactions();
    }

  }, [canFetch, compCode, walletCode, getTransactionsOfWallet]); // Dependencies that trigger a refetch

  useEffect(() => {
    if (!canFetch) {
      setTrans(transactions);
    }
  }, [transactions, canFetch]); 


  const { oppositeTheme } = useTheme();

  const handleClick = useCallback((id) => {
    clickTransaction(id);
  }, [clickTransaction]);

  const hasTransactions = Array.isArray(trans) && trans.length > 0;

  return (
    <>
      <table className="table table-responsive table-sm table-striped">
        <thead>
          <tr className={'m-4'}>
            <th className={`text-${oppositeTheme}`}>Datum</th>
            <th className={`text-${oppositeTheme} d-none d-lg-table-cell`}>Tijd</th>
            {/* Check if 'trans' is a non-empty array before accessing [0] */}
            {hasTransactions && trans[0]?.firstname ? (
              <th className={`text-${oppositeTheme}`}>Gebruiker</th>
            ) : null}
            <th className={`text-${oppositeTheme}`}>Bedrag</th>
          </tr>
        </thead>
        <tbody>
          {/* Ensure 'trans' is an array before mapping to prevent errors */}
          {hasTransactions && trans.map(t => (
            <Transaction
              clickTransaction={handleClick}
              key={t.id}
              id={t.id}
              firstname={t.firstname}
              lastname={t.lastname}
              amount={t.amount}
              timestamp={t.timestamp}
              orderlines={t.orderlines}
            />
          ))}
        </tbody>
      </table>
    </>
  );
}